import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import router from '@/router';
import { ProductOrder } from '@/services/products.service';
import store from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BadgedCart',
  setup(__props) {

const productsInCart = computed<ProductOrder[] | never[]>(
  () => store.state.cart ?? '[]',
);
const cartContentLength = computed<number>(() => productsInCart.value.length);
const showCartBadge = computed(() => cartContentLength.value > 0);

const openCart = () => {
  router.push({ name: 'cart' });
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "badged-icon",
    onClick: openCart
  }, [
    _createVNode(_component_Icon, {
      icon: "la:shopping-cart",
      width: "26px",
      height: "26px"
    }),
    _withDirectives(_createElementVNode("span", { class: "badge" }, _toDisplayString(cartContentLength.value), 513), [
      [_vShow, showCartBadge.value]
    ])
  ]))
}
}

})